import React, { useEffect, useState } from "react";
import styles from "../_css/StaticContent.module.css";
import ToggleButton from "../_components/UI/ToggleButton";
import { CustomButtonWhite } from "../_components/UI/CustomButtons";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  T_AND_C_DATA_FOOTER_CARD,
  T_AND_C_DATA,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
} from "../data/t&cData";
import { FOOTER } from "../data/commonComponents";
import HelpAndSupportModal from "../_components/Modals/HelpAndSupportModal";
import Header from "../_components/common/Header";

function TermsAndConditions() {
  const lang = useSelector((state) => state.language.lang);
  const { needHelp, content } = T_AND_C_DATA_FOOTER_CARD[lang];
  const { contactUs, termsAndConditions, privacyPolicy } = FOOTER[lang];
  const { title } = T_AND_C_DATA[lang];

  const [selectedOption, setSelectedOption] = useState(termsAndConditions);
  const [selectedContent, setSelectedContent] = useState(
    TERMS_AND_CONDITIONS[lang]
  );
  const [showHelpModal, setShowHelpModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedOption(termsAndConditions);
    setSelectedContent(TERMS_AND_CONDITIONS[lang]);
  }, [lang]);

  const handleToggle = (option) => {
    setSelectedOption(option);
    if (option === termsAndConditions) {
      setSelectedContent(TERMS_AND_CONDITIONS[lang]);
    } else {
      setSelectedContent(PRIVACY_POLICY[lang]);
    }
  };

  return (
    <div className={styles.termsAndConditionsContainer}>
      {
        <Header ispublic={true} />
      }
      <div className={styles.accountSettingsHeaderLeft}>
        <i className="cursor-pointer" onClick={() => navigate("/")}>
          <ArrowLeft size={16} />
        </i>
        <h5>{title.replace("{selectedOption}", selectedOption)}</h5>
      </div>
      <div className={styles.cardContainer}>
        <div className={styles.toggleButtonContainer}>
          <ToggleButton
            options={[termsAndConditions, privacyPolicy]}
            value={selectedOption}
            onChange={handleToggle}
            className={styles.toggleButton}
          />
        </div>
        <hr className="m-0" />
        <div className={styles.contentContainer}>
          {selectedContent.map((item, index) => (
            <div className={styles.contentItem} key={item.title}>
              <h5>
                {index + 1}. {item.title}
              </h5>
              <p>
                {item.subTitle && <strong className="mb-2">{item.subTitle}</strong>}
                {Array.isArray(item.content) ? (
                  <ul className="mt-1" style={{ listStyle: item?.isSentence ? "none" : "disc", textIndent: item?.isSentence ? "0" : "0" }}>
                    {item.content.map((el, index) => (
                      <li key={index} style={{ textAlign: 'justify' }}>{el}</li>
                    ))}
                  </ul>
                ) : (
                  <p style={{ textAlign: 'justify' }}>{item.content}</p>
                )}
              </p>
            </div>
          ))}
        </div>
        <div className={styles.helpCard}>
          <div className={styles.helpCardHeader}>
            <h6 className="text-white">
              {needHelp.replace("{selectedOption}", selectedOption)}
            </h6>
            <p>{content}</p>
          </div>
          <CustomButtonWhite text={contactUs} onClick={() => window.open("https://t.me/SmartsWay125", "_blank")} />
          {/* <HelpAndSupportModal
            show={showHelpModal}
            onClose={() => {
              setShowHelpModal(false);
            }}
          /> */}
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
